import type { GradeReference } from '../../../../core/domain/Roaddata';
import { UpdateSelectedGradeReferenceCommand } from '../../../../core/networkMap/commands/UpdateSelectedGradeReferenceCommand';
import { useAppDispatch } from '../../../../types';

type UseGradesLoading = {
    handleReferenceClick: (key: string) => void;
};

const useGradesLoading = (): UseGradesLoading => {
    const dispatch = useAppDispatch();

    const handleReferenceClick = (key: string) => {
        dispatch(UpdateSelectedGradeReferenceCommand({ selectedGradeReference: key as GradeReference }));
    };

    return {
        handleReferenceClick,
    };
};

export default useGradesLoading;
